import { createClasses } from '@repo/shared-theme-utils/create-classes'

// ----------------------------------------------------------------------

export const iconifyClasses = {
  root: createClasses('iconify__root')
}
